import React from 'react';
import { View } from '@dbk/ui-react-utils';
import { createContainer } from '@dbk-legacy/muster/react';
import ChatWelcomeScreen from '../../screens/chat/subscription/chat-welcome-screen';
import ChatWidget from '../../components/chat/container';

const ChatScreen = (props) => {
  const {
    chat: { showWelcomeScreen },
    terms: { showTermsConditionsChat }
  } = props;

  if (showTermsConditionsChat) {
    if (showWelcomeScreen) {
      return (
        <ChatWelcomeScreen />
      )
    }
    else
      return <View />;

  } else {
    return (
      <ChatWidget />
    )
  }
}

export default createContainer({
  $queries: {
    chat: {
      setShowWelcomeScreen: { $set: 'showWelcomeScreen' },
      showWelcomeScreen: true
    },
    i18n: { messages: true },
    rsa: {
      rsaAuthorised: true,
      onChangePage: {
        $call: 'changePage',
      },
    },
    terms: { showTermsConditionsChat: true }
  },

})(ChatScreen);